import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthGuard } from './core/guards/auth.guard';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled'
};

export const routes: Routes = [
    { path: '', loadChildren: () => import('./modules/landing-pages/landing-pages.routes').then(m => m.routes) },
    { path: 'app', component: AppLayoutComponent, canActivate: [AuthGuard],
        children: [
            { path: 'registration-tracking', loadChildren: () => import('./modules/registration-tracking/registration-tracking.routes').then(m => m.routes) },
            { path: 'dashboard', loadChildren: () => import('./modules/dashboard/dashboard.routes').then(m => m.routes) },
            { path: 'send-money', loadChildren: () => import('./modules/send-money/send-money.routes').then(m => m.routes) },
            { path: 'payments', loadChildren: () => import('./modules/payments/payments.routes').then(m => m.routes) },
            { path: 'bundles-and-airtime', loadChildren: () => import('./modules/bundles-and-airtime/bundles-and-airtime.routes').then(m => m.routes) },
            { path: 'wallet-settings', loadChildren: () => import('./modules/wallet-settings/wallet-settings.routes').then(m => m.routes) },
            { path: 'user-management', loadChildren: () => import('./modules/user-management/user-management.routes').then(m => m.routes) },
            { path: 'account-settings', loadChildren: () => import('./modules/account-settings/account-settings.routes').then(m => m.routes) },
            { path: 'beneficiary-management', loadChildren: () => import('./modules/beneficiary-management/beneficiary-management.routes').then(m => m.routes) },
            { path: 'my-tasks', loadChildren: () => import('./modules/my-tasks/my-tasks.routes').then(m => m.routes) },
            { path: 'approval-workflow', loadChildren: () => import('./modules/approval-workflow/approval-workflow.routes').then(m => m.routes) },
            { path: 'collections', loadChildren: () => import('./modules/collections/collections.routes').then(m => m.routes) },
            { path: 'salary-advance', loadChildren: () => import('./modules/salary-advance/salary-advance.routes').then(m => m.routes  ) },
            { path: 'expense-management', loadChildren: () => import('./modules/expense-management/expense-management.routes').then(m => m.routes  ) },
            { path: 'trust-cashout', loadChildren: () => import('./modules/trust-cashout/trust-cashout.routes').then(m => m.routes  ) },
        ]
    },
    { path: 'auth', loadChildren: () => import('./modules/auth/auth.routes').then(m => m.routes) },
    { path: '**', redirectTo: '/notfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
